const healthConditions = [
  { value: 1, label: 'AIDS, ARC, HIV positive' },
  { value: 2, label: 'Emphysema/COPD' },
  { value: 3, label: 'Liver Failure' },
  { value: 4, label: 'Alcoholism' },
  { value: 5, label: 'Epilepsy/Seizure' },
  { value: 6, label: 'Lupus' },
  { value: 7, label: 'Stroke/Transient Ischemic Attack (TIA)' },
  { value: 8, label: 'Drug Abuse' },
  { value: 9, label: "ALS (Lou Gehrig's Disease)" },
  { value: 10, label: 'Gastric Bypass/Lap Band' },
  { value: 11, label: 'Melanoma' },
  { value: 12, label: 'Atrial Fibrillation' },
  { value: 13, label: 'Heart Attack' },
  { value: 14, label: 'Multiple Sclerosis (MS)' },
  { value: 15, label: 'Ulcerative Colitis (UC)' },
  { value: 16, label: 'Kidney Disease' },
  { value: 17, label: 'Rheumatoid Arthritis (RA)' },
  { value: 18, label: "Crohn's Disease" },
  { value: 19, label: 'Hepatitis B' },
  { value: 20, label: 'Sleep Apnea' },
  { value: 21, label: 'Diabetes' },
  { value: 22, label: 'Hepatitis C (active)' },
  { value: 23, label: 'Cancer (except certain skin cancers)' },
  { value: 24, label: 'Heart Valve Replacement' },
  { value: 25, label: "Barrett's Esophagus" },
  { value: 26, label: 'Heart Disease' },
  { value: 27, label: "Parkinson's Disease" },
  { value: 28, label: 'Bipolar Disease' },
  { value: 29, label: 'Heart Failure' },
  { value: 30, label: 'Peripheral Artery/Vascular Disease (PAD)/(PVD)' }
];
const aviationActivities = [
  { value: 1, label: 'Private Piloting' },
  { value: 2, label: 'Glider Flying' },
  { value: 3, label: 'Ultralight Flying' },
  { value: 4, label: 'Hot Air Ballooning' },
  { value: 5, label: 'Hang Gliding' },
  { value: 6, label: 'Paragliding' },
  { value: 7, label: 'Recreational Helicopter Flying' },
  { value: 8, label: 'Non-Commercial Flight Training' },
  { value: 9, label: 'Stunt Flying' },
  { value: 10, label: 'Aerobatics' },
  { value: 11, label: 'Skydiving' },
  { value: 12, label: 'Wingsuit Flying' },
  { value: 13, label: 'Parachuting' },
  { value: 14, label: 'Powered Paragliding' },
  { value: 15, label: 'Gyrocopter Flying' },
  { value: 16, label: 'Kite Surfing (with powered kites)' },
  { value: 17, label: 'Paramotoring' }
];

const hazardousAvocations = [
  { value: 1, label: 'Scuba Diving' },
  { value: 2, label: 'Mountain Climbing' },
  { value: 3, label: 'Motorized Vehicle Racing' },
  { value: 4, label: 'Skydiving' },
  { value: 5, label: 'Hang Gliding' },
  { value: 6, label: 'Bungee Jumping' },
  { value: 7, label: 'Martial Arts' },
  { value: 8, label: 'Big Game Hunting' },
  { value: 9, label: 'Whitewater Rafting and Kayaking' },
  { value: 10, label: 'Surfing' },
  { value: 11, label: 'Skiing and Snowboarding' },
  { value: 12, label: 'Caving (Spelunking)' },
  { value: 13, label: 'Rodeo' },
  { value: 14, label: 'Sailing' },
  { value: 15, label: 'Boxing' },
  { value: 16, label: 'Triathlon and Ironman Competitions' },
  { value: 17, label: 'Parkour and Freerunning' },
  { value: 18, label: 'Extreme Sports' },
  { value: 19, label: 'Endurance Racing' },
  { value: 20, label: 'Hot Air Ballooning' },
  { value: 21, label: 'Bullfighting' },
  { value: 22, label: 'Firefighting' },
  { value: 23, label: 'Explosive Handling' },
  { value: 24, label: 'High-Risk Travel' },
  { value: 25, label: 'Extreme Weather Sports' },
  { value: 26, label: 'High-Speed Water Sports' },
  { value: 27, label: 'Animal Training' },
  { value: 28, label: 'High-Risk Construction' },
  { value: 29, label: 'Competitive Shooting' },
  { value: 30, label: 'Extreme Endurance Events' },
  { value: 31, label: 'High-Risk Cycling' },
  { value: 32, label: 'High-Risk Winter Sports' },
  { value: 33, label: 'Extreme Skateboarding' },
  { value: 34, label: 'High-Risk Martial Arts' },
  { value: 35, label: 'High-Risk Water Activities' },
  { value: 36, label: 'High-Risk Motor Sports' },
  { value: 37, label: 'High-Risk Equestrian Sports' },
  { value: 38, label: 'High-Risk Urban Exploration' }
];

const cancerTypes = [
  { value: 0, label: 'N/A' },
  { value: 1, label: 'Breast' },
  { value: 2, label: 'Cervical' },
  { value: 3, label: 'Endometrial' },
  { value: 4, label: 'Fallopian Tube' },
  { value: 5, label: 'Ovarian' },
  { value: 6, label: 'Vaginal' },
  { value: 7, label: 'Vulvar' },
  { value: 8, label: 'Prostate' },
  { value: 9, label: 'Testicular' },
  { value: 10, label: 'Stomach' },
  { value: 11, label: 'Colon' },
  { value: 12, label: 'Pancreatic' },
  { value: 13, label: 'Melanoma' },
  { value: 14, label: 'Lung' },
  { value: 15, label: 'Other' }
];

export const HealthAnalyzer = {
  HEALTH_CONDITIONS: healthConditions,
  AVIATION_ACTIVITIES: aviationActivities,
  HAZARDOUS_AVOCATIONS: hazardousAvocations,
  CANCER_TYPES: cancerTypes,
  HEALTH_CONDITION_VALUES: healthConditions.map(condition => condition.value)
};
